<template>
  <div>
    <v-card
      :style="[
        $vuetify.breakpoint.height < 786
          ? { 'min-height': '100vh', 'background-color': '#E9E9E9' }
          : $vuetify.breakpoint.height == 947 || $vuetify.breakpoint.height == 789 ? { 'min-height': '91vh', 'background-color': '#E9E9E9' }
          : $vuetify.breakpoint.height == 969 ? { 'min-height': '91vh', 'background-color': '#E9E9E9' }
          : { height: 'auto', 'background-color': '#E9E9E9' },
      ]"
    >
      <div style="margin-left: 10px; margin-right: 10px">
        <div
          style="
              font-size: 18px;
              margin-left: 1rem;
              margin-right: 1rem;
              color: #444444;
              cursor: default;
              margin-top: -1rem;
            "
        ></div>
        <v-card-text>
          <div>
            <v-row cols="12" xs="12" sm="12" md="12" justify="center">
              <v-col cols="12" md="8" align="center">
                <v-text-field
                  class="centered-input-header"
                  :value="SiteName == '' || RedemptionPageActiveStatus == false ? '' : SiteName"
                  disabled
                  solo
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row cols="12" xs="12" sm="12" md="12" justify="center">
              <v-col cols="12" md="4" align="center">
                <p style="text-align: center; font-size: 22px; color: #14223c; cursor: pointer;" @click="OpenCheckPermissionDialog()">
                  {{ $t("message.Redemption") }}
                </p>
              </v-col>
            </v-row>
            <v-row cols="12" xs="12" sm="12" md="12" justify="center">
              <v-col cols="12" md="10" align="center">
                <v-img
                  src="@/assets/stamp.png"
                  width="100"
                  class="mx-auto"
                ></v-img>
              </v-col>
            </v-row>
            <v-row cols="12" xs="12" sm="12" md="12" justify="center">
              <v-col cols="12" md="4" align="center">
                <p style="text-align: center; font-size: 20px; color: green;">
                  {{ $t("message.RedemptionSuccess") }}
                </p>
              </v-col>
            </v-row>         
            <v-row cols="12" xs="12" sm="12" md="12" justify="center">
              <v-col cols="12" md="7" align="center" class="white rounded-sm">
                <table style="border-collapse: collapse; width: 100%">
                  <tr>
                    <td style="color: #14223c">{{ $t("message.TicketNo") }}</td>
                    <td style="text-align: right; color: #14223c">
                      {{ TicketNo }}
                    </td>
                  </tr>
                  <tr>
                    <td style="color: #14223c">{{ $t("message.DateTime") }}</td>
                    <td style="text-align: right; color: #14223c">
                      {{ DateTime }}
                    </td>
                  </tr>
                  <tr>
                    <td style="color: #14223c">{{ $t("message.TimeIn") }}</td>
                    <td style="text-align: right; color: #14223c">
                      {{ TimeIn }}
                    </td>
                  </tr>
                  <tr>
                    <td style="color: #14223c">{{ $t("message.Duration") }}</td>
                    <td style="text-align: right">{{ Duration }}</td>
                  </tr>
                  <tr>
                    <td style="color: #14223c">
                      {{ $t("message.CarLicense") }}
                    </td>
                    <td style="text-align: right; color: #14223c">
                      {{ CarLicense }}
                    </td>
                  </tr>
                  <tr>
                    <td style="color: #14223c">
                      {{ $t("message.VehicleName") }}
                    </td>
                    <td style="text-align: right; color: #14223c">
                      {{ VehicleName }}
                    </td>
                  </tr>
                  <tr>
                    <td style="color: #14223c;">
                      {{ $t("message.NormalServiceRateRedemptionPage") }}
                    </td>
                    <td style="text-align: right; color: #14223c">
                      <div>{{ ($t("message.RateDetailLang") == "ENG" ? RateDetailENG.split('\r\n')[0] : RateDetail.split('\r\n')[0]) }}</div>
                      <div>{{ ($t("message.RateDetailLang") == "ENG" ? RateDetailENG.split('\r\n')[1] : RateDetail.split('\r\n')[1]) }}</div>
                    </td>
                  </tr>
                  <!-- <tr>
                    <td style="color: #14223c"></td>
                    <td style="text-align: right; color: #14223c">
                      <div>{{ ($t("message.RateDetailLang") == "ENG" ? RateDetailENG.split('\r\n')[0] : RateDetail.split('\r\n')[0]) }}</div>
                      <div>{{ ($t("message.RateDetailLang") == "ENG" ? RateDetailENG.split('\r\n')[1] : RateDetail.split('\r\n')[1]) }}</div>
                    </td>
                  </tr> -->
                  <tr
                    v-show="
                      (UsagePOSValue != 0 && UsagePOSValue != null) ||
                        (UsageCouponValue != 0 && UsageCouponValue != null)
                    "
                  >
                    <td style="color: #14223c;text-decoration: underline;">
                      {{ $t("message.PromotionDiscount") }}
                    </td>
                  </tr>

                  <tr v-show="UsagePOSValue != 0 && UsagePOSValue != null">
                    <td style="color: #14223c;text-indent: 2em;">
                      {{ $t("message.ReceiptFromPurchase") }}
                    </td>
                    <td style="text-align: right; color: #14223c">
                      {{ UsagePOSValue }} {{ $t("message.Hour") }}
                    </td>
                  </tr>

                  <tr
                    v-show="UsageCouponValue != 0 && UsageCouponValue != null"
                  >
                    <td style="color: #14223c;text-indent: 2em;">
                      {{ $t("message.UsageCoupon") }}
                    </td>
                    <td style="text-align: right; color: #14223c">
                      {{ UsageCouponValue }} {{ $t("message.Hour") }}
                    </td>
                  </tr>
                  <tr
                    v-show="
                      (UsagePOSValue != 0 && UsagePOSValue != null) ||
                        (UsageCouponValue != 0 && UsageCouponValue != null)
                    "
                  >
                    <td style="color: #14223c;text-indent: 2em;">
                      {{ $t("message.TotalPromotionDiscount") }}
                    </td>
                    <td style="text-align: right; color: #14223c">
                      {{ UsagePOSValue + UsageCouponValue }}
                      {{ $t("message.Hour") }}
                    </td>
                  </tr>

                  <tr>
                    <td style="color: #14223c">{{ $t("message.Total") }}</td>
                    <td style="text-align: right; color: green" v-show="Total != ''">
                      {{ numberWithCommas(Total) }}
                      <span style="color: black;">
                        {{ $t("message.Baht") }}</span
                      >
                    </td>
                  </tr>
                </table>
              </v-col>
            </v-row>
            <br/>
            <!-- <v-divider></v-divider> -->
            <!-- <v-row cols="12" xs="12" sm="12" md="12" justify="center">
                <v-col cols="12" md="6" align="center">
                    <p style="font-size: 16px; text-align: left;">{{$t("message.RateDetail")}}</p>
                    <v-text-field
                      v-model="Rate"
                      disabled
                      solo
                    ></v-text-field>
                </v-col>
              </v-row> -->
            <v-row cols="12" xs="12" sm="12" md="12" justify="center">
              <v-col cols="12" md="4" align="center">
                <v-btn
                  height="40"
                  width="150"
                  outlined
                  color="indigo"
                  @click="BackToMain()"
                >
                  {{ $t("message.Back") }}
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4"></v-col>
            </v-row>
          </div>
        </v-card-text>
      </div>
    </v-card>
    <br />
    <v-footer
      color="#1d2939"
      :absolute="$vuetify.breakpoint.height < 786 ? false : true"
      class="white--text text-caption footer"
    >
      <v-row no-gutters>
        <v-col cols="12" xs="12" sm="12" md="12">
          <v-row no-gutters>
            <v-col cols="12" xs="12" sm="4" md="4" lg="2"></v-col>
            <v-col cols="12" xs="12" sm="4" md="4" lg="1">
              <v-img
                src="@/assets/logo_fs.svg"
                width="80"
                class="mx-auto mt-1"
              ></v-img>
            </v-col>
            <v-col cols="12" xs="12" sm="4" md="4" lg="3">
              <div class="mt-2">
                <span style="font-size: small; margin-bottom: 5px; color: white"
                  >Copyright © 2023 Forward System Co. Ltd. All rights reserved.</span
                >
              </div>
            </v-col>
            <v-col cols="12" xs="12" sm="4" md="4" lg="6"></v-col>
          </v-row>
        </v-col>
        <v-col cols="12" xs="12" sm="2" md="2"> </v-col>
      </v-row>
    </v-footer>

    <v-dialog v-model="LoadingDialog" persistent width="0.01">
      <v-card>
        <v-card-text>
          <v-row>
            <LoadingComponent class="centered"></LoadingComponent>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="CheckPermissionDialog" persistent width="300">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn
            style="margin-top: -10px; z-index: 1"
            @click="CloseCheckPermissionDialog()"
            icon
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row style="margin-bottom: -50px">
            <v-col cols="12" md="1"></v-col>
            <v-col cols="12" md="10">
              <v-text-field
                placeholder="Username"
                type="text"
                outlined
                v-model="UserAdmin"
                @keyup.enter="LoginPermission"
              />
              <v-text-field
                placeholder="Password"
                type="password"
                outlined
                v-model="PasswordAdmin"
                @keyup.enter="LoginPermission"
              />
            </v-col>
            <v-col cols="12" md="1"></v-col>
          </v-row>
          <v-row style="margin-bottom: -40px">
            <v-col cols="12" md="1"></v-col>
            <v-col cols="12" md="10">
              <v-btn
                block
                color="#1D2939"
                style="color: white"
                @click="LoginPermission()"
                class="rounded-lg"
                x-large
                >Login</v-btn
              >
            </v-col>
            <v-col cols="12" md="1"></v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="SettingRedemptionDialog" persistent width="800">
      <v-card>
        <v-card-title>
          <p>Setting</p>
          <v-spacer></v-spacer>
          <v-btn
            style="margin-top: -10px; z-index: 1"
            @click="CloseSettingRedemptionDialog()"
            icon
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row class="ml-5 mr-2">
            <v-col col="12" md="6">
              <p style="font-size: 13px; color: black">Site Name</p>
              <v-text-field v-model="SiteName" solo></v-text-field>
            </v-col>
            <v-col col="12" md="6">
              <!-- <p style="font-size: 13px; color: black">Header Name</p>
              <v-text-field v-model="HeaderName" solo></v-text-field> -->
            </v-col>
          </v-row>
          <v-row class="ml-5 mr-2">
            <v-col col="12" md="6">
              <p style="font-size: 13px; color: black">SiteName Color</p>
              <div>
                <v-color-picker
                  v-model="SiteNameColor"
                  dot-size="20"
                  class="ma-2"
                  mode="hexa"
                ></v-color-picker>
              </div>
            </v-col>
            <v-col col="12" md="6">
              <p style="font-size: 13px; color: black">BackgroundColor Color</p>
              <div>
                <v-color-picker
                  v-model="BackgroundColor"
                  dot-size="20"
                  class="ma-2"
                  mode="hexa"
                ></v-color-picker>
              </div>
            </v-col>
          </v-row>
          <v-row class="ml-5 mr-2">
            <p style="text-align: left; font-size: 16px; color: black">
              Status
            </p>
            <v-radio-group inline v-model="RedemptionPageActiveStatus">
              <v-radio label="Active" value="1"></v-radio>
              <v-radio label="InActive" value="2"></v-radio>
            </v-radio-group>
          </v-row>
          <hr class="mt-2" />
          <v-row>
            <v-col cols="12" md="1"></v-col>
            <v-col cols="12" md="1"></v-col>
            <v-col cols="12" md="10" align="right">
              <v-btn
                height="40"
                width="150"
                color="success"
                outlined
                @click="SaveSettingRedemptionPage()"
              >
                {{ $t("message.Submit") }}
              </v-btn>
              <v-btn height="40" width="150" color="red" outlined @click="CloseSettingRedemptionDialog()">
                {{ $t("message.Cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import enurl from "@/api/environment";
import LoadingComponent from "@/components/Loading";
export default {
  name: "Redemption",
  components: {
    LoadingComponent,
  },
  data() {
    return {
      url: enurl.apiUrl,
      LoadingDialog: false,
      AlertDialog: false,
      TypeAlert: null,
      MessageAlert: "",
      Rate: "",
      ResponseRedeem: [],

      TerminalID: null,
      DatetimeIn: "",
      MemberType: null,
      CarType: null,
      UserID: null,

      TicketNo: "",
      DateTime: "",
      TimeIn: "",
      Duration: "",
      CarLicense: "",
      VehicleName: "",
      RateCodeString: "",
      RateDetail: "",
      RateDetailENG: "",
      Total: "",

      UsagePOSValue: 0,
      UsageCouponValue: 0,
      TenantID: parseInt(localStorage.getItem("TenantID")),
      DepartmentID: localStorage.getItem("departmentId"),

      UserAdmin: "",
      PasswordAdmin: "",
      CheckPermissionDialog: false,
      SettingRedemptionDialog: false,
      ThemeColor: "",
      SiteName: "",
      SiteNameColor: "",
      BackgroundColor: "",
      RedemptionPageActiveStatus: false,
    };
  },

  methods: {
    BackToMain() {
      let self = this;
      self.$router.push("/Main");
    },

    BindingDataResponse() {
      let self = this;
      if (self.ResponseRedeem != "" && self.ResponseRedeem != undefined) {
        if (
          self.ResponseRedeem.length > 0 &&
          self.ResponseRedeem[0].status != "Fail"
        ) {
          self.TerminalID = self.ResponseRedeem[0].terminalInId;
          self.DatetimeIn = self.ResponseRedeem[0].entryDateTime;
          self.MemberType = self.ResponseRedeem[0].memberTypeId;
          self.CarType = self.ResponseRedeem[0].vehicleTypeId;
          self.TicketNo = self.ResponseRedeem[0].ticketNo;
          self.DateTime = new Date(
            self.ResponseRedeem[0].entryDateTime
          ).toLocaleDateString("en-us", {
            year: "numeric",
            month: "short",
            day: "numeric",
          });
          self.TimeIn =
            self.ResponseRedeem[0].entryDateTime.split(" ").length > 0
              ? self.ResponseRedeem[0].entryDateTime.split(" ")[1]
              : "";
          self.Duration =
            self.ResponseRedeem[0].parkHH +
            " hrs " +
            self.ResponseRedeem[0].parkMM +
            " mins";
          self.CarLicense = self.ResponseRedeem[0].plateNo;
          self.VehicleName = self.ResponseRedeem[0].vehicleTypeName;
          self.RateCodeString = self.ResponseRedeem[0].rateCode;
          self.RateDetail = self.ResponseRedeem[0].rateDetailTH;
          self.RateDetailENG = self.ResponseRedeem[0].rateDetailEN;
          self.Total = self.ResponseRedeem[0].total;
          this.GetDataRateCode(
            self.ResponseRedeem[0].memberTypeId,
            self.ResponseRedeem[0].vehicleTypeId
          );
          // console.log(self.response[0]);
        }
      }
    },

    GetDataRateCode(membertype, vehicletype) {
      let self = this;
      // self.LoadingDialog = true;
      let temp = {
        TenantID: self.TenantID,
        MemberType: membertype,
        VehicleType: vehicletype,
        DepartmentID: parseInt(self.DepartmentID),
      };
      axios
        .post(`${self.url}Redemption/GetDataRateCode`, temp)
        .then(function(response) {
          if (response.data.status == 0) {
            self.RateList = response.data.data;
            // self.LoadingDialog = false;
          }
        })
        .catch(function(error) {
          self.MessageAlert = error;
          self.TypeAlert = "error";
          self.AlertDialog = true;
          // self.LoadingDialog = false;
        });
    },

    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    OpenCheckPermissionDialog() {
      let self = this;
      self.CheckPermissionDialog = true;
    },

    CloseCheckPermissionDialog() {
      let self = this;
      self.UserAdmin = "";
      self.PasswordAdmin = "";
      self.CheckPermissionDialog = false;
    },

    LoginPermission() {
      let self = this;
      if (
        self.UserAdmin.toLocaleLowerCase() == "admin" &&
        self.PasswordAdmin.toLocaleLowerCase() == "fscp_1"
      ) {
        self.OpenSettingRedemptionPage();
      } else {
        alert("รหัสผ่านไม่ถูกต้อง !");
      }
    },

    OpenSettingRedemptionPage() {
      let self = this;
      self.SettingRedemptionDialog = true;
    },

    CloseSettingRedemptionDialog() {
      let self = this;
      self.CheckPermissionDialog = false;
      self.SettingRedemptionDialog = false;
    },

    async LoadDataSettingRedemption() {
      let self = this;
      await axios
        .get(`${self.url}Setting/LoadDataSettingRedemption`)
        .then(function (response) {
          if (response.data.status == 0) {
            if (response.data.data.activeStatus == true) {
              self.SiteName = response.data.data.siteName;
              // self.HeaderName = response.data.data.headerName;
              self.SiteNameColor = response.data.data.siteNameColor;
              self.BackgroundColor = response.data.data.backgroundColor;
              self.RedemptionPageActiveStatus = response.data.data.activeStatus == true ? "1" : "2";
              self.ThemeColor = response.data.data.themeColor;
            }
          }
        })
        .catch(function (error) {
          alert(error);
        });
    },

    SaveSettingRedemptionPage() {
      let self = this;
      let temp = {
        SiteName: self.SiteName,
        // HeaderName: self.HeaderName,
        SiteNameColor: self.SiteNameColor,
        BackgroundColor: self.BackgroundColor,
        RedemptionPageActiveStatus: self.RedemptionPageActiveStatus,
      };
      axios
        .post(`${self.url}Setting/SaveSettingRedemptionPage`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            // alert(response.data.message);
            self.SettingRedemptionDialog = false;
            self.CheckPermissionDialog = false;
            self.LoadDataSettingRedemption();
          }
        })
        .catch(function (error) {
          alert(error);
        });
    },

  },

  mounted() {
    this.Rate = this.$route.params.ratecode;
    this.ResponseRedeem = this.$route.params.ResponseRedeem;
    // console.log(this.$route.params.ResponseRedeem);
    this.BindingDataResponse();
    this.LoadDataSettingRedemption();
  },
};
</script>
<style scoped>
.centered-input-header >>> input {
  text-align: center;
  color: black;
}
.TitleCSS {
  font-size: 18px;
  font-weight: 300;
}
@font-face {
  font-family: "English";
  src: local("English"), url(../assets/Font/Kanit-Regular.ttf);
}
* >>> .v-data-table-header {
  background-color: #333333 !important;
  color: #ffffff !important;
}
* >>> .v-data-table-header th {
  font-size: 14px !important;
  color: #ffffff !important;
}
.addUserTitle {
  font-size: 14px;
  font-weight: 300;
}
.input-border {
  border: 1px solid black;
  height: 35px;
  padding: 4px;
}
.validation-class {
  color: red;
  font-size: 12px;
}
.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  color: white;
  text-align: center;
}
.centered {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
